import debounce from 'lodash/debounce';
import ionRangeSlider from '../../../../../libs/vanilla-rangeslider-master/js/rangeslider';

interface TParams {
    name: string;
    values: (number | string)[];
}

interface TOptions {
    onChange?(params: TParams): void;
    onInit?(params: TParams): void;
}

class RangeInput {
    private readonly rangeInst;

    constructor(parent: HTMLElement, options?: TOptions) {
        if (!parent) {
            console.warn(`Parent is ${parent}`);

            return;
        }

        const root = parent.querySelector('.range-input__root') as HTMLInputElement;
        const inputFrom = parent.querySelector('.range-input__from input') as HTMLInputElement;
        const inputTo = parent.querySelector('.range-input__to input') as HTMLInputElement;

        if (!root || !inputFrom || !inputTo) {
            console.warn(`Elements root: ${root}, from: ${inputFrom}, to: ${inputTo}`);

            return;
        }

        const debounceOnChange = debounce(({from, to}) => {
            if (typeof options?.onChange === 'function') {
                options?.onChange({name  : root.name,
                    values: [from, to]});
            }
        }, 300);

        this.rangeInst = ionRangeSlider(root, {
            onChange: ({from, to}) => {
                inputFrom.value = from;
                inputTo.value = to;
                inputFrom.max = to;
                inputTo.min = from;

                debounceOnChange({from,
                    to});
            },
            onUpdate: ({from, to}) => {
                inputFrom.value = from;
                inputTo.value = to;
                inputFrom.max = to;
                inputTo.min = from;

                debounceOnChange({from,
                    to});
            },
            onStart: ({from, to}) => {
                inputFrom.value = from;
                inputTo.value = to;
                inputFrom.max = to;
                inputTo.min = from;

                if (options?.onInit) {
                    options.onInit({name  : root.name,
                        values: [from, to]});
                }
            }
        });

        inputFrom.addEventListener('input', debounce((env) => {
            this.rangeInst.update({
                from: (env.target as HTMLInputElement).value
            });
        }, 3000));

        inputTo.addEventListener('input', debounce((env) => {
            this.rangeInst.update({
                to: (env.target as HTMLInputElement).value
            });
        }, 3000));

        inputFrom.addEventListener('blur', (env) => {
            this.rangeInst.update({
                from: (env.target as HTMLInputElement).value
            });
        });

        inputTo.addEventListener('blur', (env) => {
            this.rangeInst.update({
                to: (env.target as HTMLInputElement).value
            });
        });
    }

    reset(): void {
        this.rangeInst.update({
            from: this.rangeInst.min,
            to  : this.rangeInst.max
        });
    }
}

export default RangeInput;
